import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21eb5587"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-queue-modal-main" }
const _hoisted_2 = { class: "edit-queue-modal-main_breadcrumbs" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "edit-queue-modal-main_breadcrumbs_title",
  textContent: 'Местонахождение'
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-queue-modal_border" }, null, -1))

import { SettingsBreadcrumbsModel } from "@/components/menu-breadcrumbs";
import MenuBreadcrumbs from "@/components/menu-breadcrumbs/menu-breadcrumbs.vue";
import { QueueTasksModel } from "@/components/sidebar/models";
import { computed, onMounted, PropType, ref, watch } from "vue";
import { TirPmInput } from "tir-components";
import { EditQueueAdapterService } from "../adapter-service";

/**API сервис */

export default /*#__PURE__*/_defineComponent({
  __name: 'edit-queue-modal-main',
  props: {
  /**Id редактируемой очереди */
  queue: { type: Object as PropType<QueueTasksModel> },
},
  setup(__props) {

const props = __props;

const apiService = new EditQueueAdapterService();

/**Параметры */


/**Имя очереди */
const innerName = ref("");

/**Информация об очереди */
const settingsBreadcrumbs = computed(
  () =>
    new SettingsBreadcrumbsModel({
      NamespaceId: props.queue?.NamespaceId,
      GroupId: props.queue?.ParentGroupId,
      QueueId: props.queue?.Id?.toString(),
    }),
);

/**После рендера */
onMounted(() => setInnerName());

/**Отслеживание изменений очереди */
watch(() => props.queue, setInnerName, { deep: true });

/**Установка значения поля innerName */
function setInnerName() {
  innerName.value = props.queue.Name || "";
}
/**Смена имени очереди */
const changeName = () => {
  if (!innerName.value.length) {
    innerName.value = props.queue.Name;
    return;
  }

  (document?.activeElement as HTMLElement)?.blur?.();

  apiService.updateName(props.queue.Id, innerName.value);
  props.queue.Name = innerName.value;

  document.dispatchEvent(
    new CustomEvent("update-queue-name", {
      detail: {
        QueueId: props.queue.Id,
        Name: innerName.value,
      },
    }),
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(MenuBreadcrumbs, {
        "no-route": "",
        settings: settingsBreadcrumbs.value
      }, null, 8, ["settings"])
    ]),
    _hoisted_4,
    _createVNode(_unref(TirPmInput), {
      label: "Название очереди",
      modelValue: innerName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerName).value = $event)),
      onEnter: changeName,
      onBlur: changeName
    }, null, 8, ["modelValue"])
  ]))
}
}

})